var _defs, _rect, _circle, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2BInvite3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2bInvite3Sky",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f3d6c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#d9a48c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4a2e3a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#b2bInvite3Sky)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 180,
    r: 220,
    fill: "#ffe9d6",
    opacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 240,
    width: 420,
    height: 520,
    rx: 12,
    fill: "#f8f1ea",
    opacity: 0.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 280,
    width: 340,
    height: 440,
    rx: 8,
    fill: "#2d1b22",
    opacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 620 C 300 540 560 700 860 580 C 1140 480 1380 640 1600 540 L 1600 900 L 0 900 Z",
    fill: "#24151c",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BInvite3);
export default __webpack_public_path__ + "static/media/b2b-invite-3.048874daa34ee9c00c52561e45edf356.svg";
export { ForwardRef as ReactComponent };